import { get } from 'lodash';

const root = state => get(state, 'PhysicalState.createEditPhysical');
export const getPhysicalItems = state => get(root(state), 'physicalItems', []);
export const getPhysicalItemsLoadingError = state =>
  get(root(state), 'physicalItemsLoadingError', null);
export const getFetchPhysicalItems = state =>
  get(root(state), 'fetchPhysicalItems', false);
export const getLoading = state => get(root(state), 'loading', false);
export const getSubmitted = state => get(root(state), 'submitted', false);
export const getSubmitError = state => get(root(state), 'submitError', null);
export const getSubmitting = state => get(root(state), 'submitting', false);
export const getFetchingPhysicalDetail = state =>
  get(root(state), 'fetchingPhysicalDetail', false);
export const getSelectedPhysicalDetail = state =>
  get(root(state), 'selectedPhysicalDetail', null);
export const getFetchPhysicalDetailError = state =>
  get(root(state), 'fetchPhysicalDetailError', null);
export const getFetchPhysicalOnHandError = state =>
  get(root(state), 'fetchPhysicalOnHandError', null);
export const getCheckIncompletePhysical = state =>
  get(root(state), 'checkIncompletePhysical, null');
export const getCheckIncompletePhysicalError = state =>
  get(root(state), 'checkIncompletePhysicalError', null);
export const getSiteWarningCheck = state =>
  get(root(state), 'siteWarningCheck', null);
export const getSiteWarningCheckForError = state =>
  get(root(state), 'siteWarningCheckForError', null);
export const getPhysicalOnHandDetail = state =>
  get(root(state), 'physicalOnHandDetail', null);
export const getFetchingPhysicalOnHand = state =>
  get(root(state), 'fetchingPhysicalOnHand', false);
export const getIsLoadOnHandClicked = state =>
  get(root(state), 'isLoadOnHandClicked', false);
export const getSiteWarningDataLoadingError = state =>
  get(root(state), 'siteWarningDataLoadingError', null);
export const getFetchSiteWarningDataLoading = state =>
  get(root(state), 'fetchSiteWarningDataLoading', false);



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/physical/state/CreateEditPhysical/selectors.js